import React, { useEffect, useState } from "react";
import axios from "axios";
import FamilyList from "./FamilyList";
import addicon from "../../Images/Refrence/Icon ionic-md-add.svg";
import AddFamilyMember from "./AddFamilyMember";
import "./FamilyTree.css"
const FamilyTree = () => {
    const [FamilyTList, setFamilyTList] = useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const token = localStorage.getItem("smc-csp-token")
    const GetFamilyData = async () => {
        try {
            const Res = await axios.get("https://www.smcinsurance.com/CustomerPanelApi/api/Customers/GetCustomerFamilyTree", { headers: { Authorization: `Bearer ${token}` } });
            console.log("Res", Res)
            setFamilyTList(Res.data.Data);
        } catch (err) { }
    }

    const AddMember = () => {
        setShow(true)
    }

    useEffect(() => {
        GetFamilyData();
    }, [])

    return (
        <div className="FamilyTreeContainer">
            <div className="FamilyTree">
                <FamilyList FamilyListData={FamilyTList} />

                <AddFamilyMember Show={show} close={handleClose} />
                <div className="FamilyTreeBox addMember" onClick={AddMember}>
                    <img alt="" src={addicon} />
                    <p>Add New Member</p>
                </div>
            </div>
        </div>

    )
}
export default FamilyTree;